import React, { useState, useEffect } from "react";
import "./Nav.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Assets/logo.png";

import menu from "../../Assets/vectors/Icons/menu.svg";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 1) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <nav className={scrolled ? "flex navDropShadow" : "flex"}>
      <div className="navElementContainer flex">
        <Link to="/" className="flex">
          <img src={logo} alt="" className="mr05" />
        </Link>
        <ul className={open ? "flex none show" : "flex none"}>
          <li>
            <Link to="/">Home</Link>
            {location.pathname === "/" && <div className="navSelected"></div>}
          </li>
          <li>
            <Link to="/about">About Us</Link>
            {location.pathname === "/about" && (
              <div className="navSelected"></div>
            )}
          </li>
          <li>
            <Link to="/admission">Admission</Link>
            {location.pathname === "/admission" && (
              <div className="navSelected"></div>
            )}
          </li>
          <li>
            <Link to="/gallery">Gallery</Link>
            {location.pathname === "/gallery" && (
              <div className="navSelected"></div>
            )}
          </li>
          <li>
            <Link to="/contact">Contact</Link>
            {location.pathname === "/contact" && (
              <div className="navSelected"></div>
            )}
          </li>
          <li>
            <Link to="/login">
              <button className="bt ripple" style={{ height: "32px" }}>
                Login
              </button>
            </Link>
            {location.pathname === "/login" && (
              <div className="navSelected"></div>
            )}
          </li>
        </ul>
        <img
          src={menu}
          className="menu"
          onClick={() => setOpen((val) => !val)}
          alt=""
        />
      </div>
    </nav>
  );
}
